<template>
  <!-- <div class="header" :class="{ 'linear-bg': isLinear, 'common-bg': !isLinear }"> -->
  <div class="header common-bg">
    <!-- 对话框 -->
    <el-dialog title="使用浏览器-扫码下载" :visible.sync="dialogVisible" :modal="false" width="50%">
      <!-- <span>打开浏览器，扫码下载APP。</span> -->
      <img src="~@/common/img/download_app.png" alt="download_app" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 左 -->
    <div class="left">
      <router-link to="/home">
        <el-image class="logo" :src="staticsHost+schoolInfo.logo_url">
          <div slot="error" class="image-err-slot">
            <i>LOGO</i>
          </div>
        </el-image>
      </router-link>
      <!-- <el-dropdown @command="selectNav">
        <span class="el-dropdown-link">
          {{ currentNavName }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="item" v-for="(item, index) in navList" :key="index">{{ item.name }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <!-- 中 -->
    <div class="center-nav" v-show="navShow">
      <div class="menu-list">
        <div @click="selectNav(item)" v-for="(item,index) in navList" :key="index" class="menu-item" :class="{active:currentNavName==item.name}">{{ item.name }}</div>
      </div>
    </div>
    <!-- <div class="center" v-if="navList && navList.length > 0">
      <el-input placeholder="请输入关键字" v-model.trim="keyword" prefix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
      <el-button class="search-btn" icon="el-icon-search" round @click="search">搜索</el-button>
    </div> -->
    <!-- 右 -->
    <div class="right">
      <!-- <div class="app-download" @click="downloadApp">
        <el-button
          class="app-download-btn"
          icon="el-icon-mobile-phone"
          circle
        ></el-button>
        <span class="icon-text app-download-icon-text">APP下载</span>
      </div>
      <div class="app-download" @click="downloadClient">
        <el-button class="app-download-btn" icon="el-icon-mobile-phone" circle></el-button>
        <span class="icon-text app-download-icon-text">下载</span>
      </div> -->
      <div class="login" @click="goLogin" v-show="!loginStatus">
        <el-button class="login-btn" icon="el-icon-user" circle></el-button>
        <span class="icon-text unlogin-icon-text">登录 / 注册</span>
      </div>
      <div class="login" v-show="loginStatus">
        <el-dropdown @command="selectPersonNav">
          <div class="avatar">
            <el-avatar :src="user.image_url" :onerror="default_thumbnail_img"></el-avatar>
            <span class="icon-text login-icon-text">{{ user.name }}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="/space">模块导航</el-dropdown-item> -->
            <el-dropdown-item command="/space/">工作台</el-dropdown-item>
            <el-dropdown-item v-pre-handle-on-demand="()=>toPath('/mine/favorite')">我的收藏</el-dropdown-item>
            <el-dropdown-item v-pre-handle-on-demand="()=>toPath('/mine/history')">历史记录</el-dropdown-item>
            <el-dropdown-item command="/mine/setting">个人设置</el-dropdown-item>
            <el-dropdown-item command="/logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { getStorage, removeStorage } from "@/common/js/localstorage";
import { isUrl } from "@/common/js/reg";
import Api from "@/api/base";

export default {
  name: "Header",
  data() {
    return {
      schoolId: 0,
      schoolInfo: {
        org_id: "",
        org_type: "",
        org_name: "",
        org_web_path: "",
        wechat_img_url: "",
        download_url: "",
        feedback_url: "",
        official_website: "",
        official_phone: "",
        copyright: "",
        title: "",
        logo_url: "",
      },
      staticsHost: window.staticsHost,
      isLinear: false,
      hasHeaderBg: false,
      navShow: true,
      currentNavName: "全部频道",
      navList: [],
      newNavList: [],
      //搜索关键词
      keyword: "",
      //登录状态标志位
      loginStatus: false,
      //用户信息
      user: {
        id: 0,
        name: "",
        image_url: "",
      },
      default_thumbnail_img:
        'this.src="' + require("@/common/img/user_img.png") + '"',
      dialogVisible: false,
      // 机构类型 1 区域 2 学校
      orgType: getStorage("school").org_type || 2,
    };
  },
  watch: {
    $route(to, from) {
      this.setHeaderTheme();
      if (from.path === "/search") {
        this.keyword = "";
      }
      if (this.$route.query.keyword) {
        this.keyword = this.$route.query.keyword;
      }
      if (to.path === "/") {
        this.navShow = false;
      } else {
        this.navShow = true;
      }
      let navList = this.newNavList;
      for (let i = 0; i < navList.length; i++) {
        if (to.fullPath === navList[i].path) {
          this.currentNavName = navList[i].name;
        }
      }
    },
  },
  created() {
    this.getSchoolId();
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword;
    }
    this.getNavList();
    if (this.$route.path == "/") {
      this.navShow = false;
    } else {
      this.navShow = true;
    }
  },
  mounted() {
    this.setHeaderTheme();
    this.checkLoginStatus();
    this.$bus.$on("checkLoginStatus", () => {
      this.checkLoginStatus();
    });
  },
  destroyed() { },
  methods: {
    // 获取头部导航栏
    getHeaderNavList(data) {
      Api.getSpaceNavigationList(data).then((response) => {
        if (response.data.status === 0) {
          this.newNavList = response.data.data.list ? response.data.data.list : [];
          let navList = this.newNavList;
          let routePath = this.$route.fullPath;
          for (let i = 0; i < navList.length; i++) {
            if (routePath.includes(navList[i].path)) {
              this.currentNavName = navList[i].name;
            }
          }
        }
      });
    },
    toPath(path) {
      this.$router.push({ path: path })
    },
    setHeaderTheme() {
      if (this.$route.path == "/" || this.$route.path == "/home") {
        this.isLinear = true;
        this.hasHeaderBg = true;
        document.addEventListener("scroll", this.scrollHandle);
      } else {
        this.isLinear = false;
        this.hasHeaderBg = false;
        document.removeEventListener("scroll", this.scrollHandle);
      }
    },
    getSchoolId() {
      this.schoolInfo = getStorage("school");
      if (this.schoolInfo) {
        this.schoolId = this.schoolInfo.org_id;
        // return;
      }
      let data = getStorage("user");
      if (data.area_type == 2) {
        let tempData = {
          school_id: data.area_id
        };
        this.getHeaderNavList(tempData);
      } else {
        let tempData = {
          area_id: data.area_id
        };
        this.getHeaderNavList(tempData);
      }
    },
    //监听页面滚动高度
    scrollHandle() {
      // 获取页面滚动高度
      let top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (top < 10) {
        this.isLinear = true;
      } else {
        this.isLinear = false;
      }
    },
    //搜索
    search() {
      if (this.keyword.trim().length === 0) {
        this.$message.warning({
          message: "搜索内容不能为空",
          duration: 1000,
        });
        return;
      }
      this.$router.push({
        path: "/search",
        query: {
          keyword: this.keyword,
        },
      });
      this.$bus.$emit("publicSearch", this.keyword);
    },
    //获取下拉菜单数据
    getNavList() {
      const routePath = this.$route.path;
      const data = this.orgType === 1 ? { area_id: this.schoolId } : { school_id: this.schoolId };
      Api.getNavigationList(data).then((response) => {
        if (response.data.status === 0) {
          let list = response.data.data.list ? response.data.data.list : [];
          let all = { path: "/home", name: "全部频道" };
          if (list.length > 1) {
            this.navList.push(all);
          }
          for (let i = 0; i < list.length; i++) {
            if (list[i].path != "/login") {
              this.navList.push(list[i]);
            }
          }
        }
        let navList = this.navList;
        for (let i = 0; i < navList.length; i++) {
          if (routePath.includes(navList[i].path)) {
            this.currentNavName = navList[i].name;
          }
        }
      });
    },
    //选择下拉菜单
    selectNav(item) {
      if (item.path == "暂无") {
        this.$message({
          type: "info",
          message: "正在开发中，敬请期待",
          duration: 1000
        })
      } else {
        const routePath = this.$route.fullPath;
        this.currentNavName = item.name;
        if (routePath !== item.path) {
          // this.$router.push({
          //   path: item.path,
          // });
          if (getStorage("user")) {
            let userPath = getStorage("user").org_web_path + item.path;
            window.open(userPath, "_self");
          }
        }
      }
    },
    //跳转登录页面
    goLogin() {
      if (window.CasClientLoginUrlAutoRedirect) {
        window.open(window.CasClientLoginUrl, "_self");
      } else {
        window.open(window.location.origin + "/#/login", "_self");
      }
    },
    //下载app
    downloadApp() {
      this.dialogVisible = true;
    },
    // 下载客户端和移动端
    downloadClient() {
      this.$router.push({
        path: "/download"
      });
    },
    //检查登录状态
    checkLoginStatus() {
      let user = getStorage("user");
      if (!user) {
        this.loginStatus = false;
      } else {
        user.image_url = isUrl(user.image_url) ? user.image_url : window.staticsHost + user.image_url;
        this.user = user;
        this.loginStatus = true;
      }
    },
    //个人功能下拉菜单
    selectPersonNav(path) {
      const routePath = this.$route.path;
      //判断当前路由与跳转路由是否同一个，避免报错
      if (routePath !== path) {
        if (path === "/logout") {
          // let accessToken = getStorage("user").access_token;
          Api.loginOut().then((response) => {
            if (response.data.status === 0) {
              removeStorage("user");
              removeStorage("school");
              removeStorage("login_area");
              this.loginStatus = false;
              if (window.CasClientLogoutAutoRedirect) {
                window.open(window.CasClientLogoutUrl, "_self")
              } else {
                if (window.CasClientLogoutLinked) {
                  // loginApi.logoutCas()
                }

                if (window.LogoutRedirectMode == "HOME") {
                  if (getStorage("pathname") != "") {
                    window.open(getStorage("pathname"), "_self");
                  } else {
                    window.open("/", "_self");
                  }
                } else if (window.CasClientLoginUrlAutoRedirect) {
                  window.open(window.CasClientLoginUrl, "_self");
                } else {
                  window.open(window.location.origin + "/#/login", "_self");
                }
              }
            } else {
              this.$message.error(response.data.info.message);
            }
          });
        } else if (path === "/space") {
          if (getStorage("user")) {
            let userPath = getStorage("user").org_web_path + "/space";
            window.open(userPath, "_self");
          }
        } else if (path === "/space/") {
          if (getStorage("user")) {
            window.open(getStorage("user").org_web_path.slice(0, getStorage("user").org_web_path.length - 2) + path, "_self");
          }
        } else if (path.includes("/manage")) {
          window.open(path, "_self");
        } else {
          this.$router.push({
            path,
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.header {
  z-index: 1999;
  display: flex;
  align-items: center;
  height: 72px;
  width: calc(100% - 200px);
  padding: 0 100px;
  position: fixed;

  .left {
    height: 100%;
    padding-left: 20px;
    display: flex;
    align-items: center;

    .logo {
      max-height: 50px;
      max-width: 200px;
      vertical-align: middle;
      text-align: left;

      /deep/ .image-err-slot {
        width: 100%;
        line-height: 50px;
        font-size: 30px;
        text-align: center;
        color: #606266;
        background-color: rgba(0, 0, 0, 0);
        vertical-align: middle;
      }

      /deep/ img {
        width: 100%;
        height: auto;
        max-height: 50px;
      }
    }

    .el-dropdown {
      margin: 0 50px;

      .el-dropdown-link {
        background: #ededed;
        padding: 8px 10px;
        border-radius: 18px;
        cursor: pointer;
        color: #2a2a2a;
        outline: none;
        font-size: 16px;
      }

      .el-icon-arrow-down {
        font-size: 14px;
      }
    }
  }

  .center {
    width: 25vw;
    height: 40px;
    min-width: 330px;
    border-radius: 20px;
    background: #E7E7E7;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    .el-input {
      width: 85%;
      font-size: 16px;
    }

    .search-btn {
      background: #559AF8;
      color: white;
      width: 80px;
      border: 0;
      height: 100%;
      font-size: 16px;
      padding: 0px 10px;
      position: absolute;
      right: -5px;
    }
  }

  .right {
    height: 100%;
    position: absolute;
    right: 120px;
    display: flex;
    align-items: center;

    .icon-text {
      margin-top: 5px;
    }

    .app-download, .login {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin: 0 20px;

      span {
        font-size: 12px;
        color: #fff;
        // text-shadow: #000 1px 0 0, #000 0 1px 0, #000 -1px 0 0, #000 0 -1px 0;
      }

      .avatar {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .el-avatar {
        // background-color: rgba(255,255,255,0);
        /deep/ img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .app-download-btn, .login-btn {
      border: none;
    }

    .app-download-btn:hover {
      background-color: #409EFF;
      color: #fff;
    }

    .login-btn:hover {
      background-color: #67C23A;
      color: #fff;
    }
  }

  .center-nav {
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    .menu-list {
      height: 100%;
      display: flex;

      .menu-item {
        height: 100%;
        line-height: 72px;
        padding: 0 20px;
        cursor: pointer;
      }

      .menu-item:hover {
        color: #1c82e7;
      }

      .menu-item.active {
        color: #1c82e7;
      }
    }
  }
}

.linear-bg {
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.005));

  .center {
    background-color: rgba(255, 255, 255, 0.2) !important;

    /deep/ .el-input__inner::-webkit-input-placeholder {
      color: #F2F6FC !important;
    }

    /deep/ .el-input__inner {
      color: #EBEEF5;
    }

    /deep/ .el-input__prefix {
      color: #F2F6FC !important;
    }
  }

  .app-download-btn, .login-btn {
    background-color: #9c9c9c;
  }

  .el-dropdown-link {
    background-color: rgba(255, 255, 255, 0.2) !important;
    color: #F2F6FC !important;
  }

  .unlogin-icon-text, .login-icon-text, .app-download-icon-text {
    color: #F2F6FC !important;
  }
}

.common-bg {
  // background-color: #39A3FE;
  background-color: #fff;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.05);

  .app-download-btn, .login-btn {
    background-color: #f6f6f6;
  }

  .el-dropdown-link {
    background: #E7E7E7 !important;
  }

  .unlogin-icon-text, .login-icon-text, .app-download-icon-text {
    // color: #fff !important;
    color: #999 !important;
  }
}

@media screen and (max-width: 1400px) {
  .header {
    .center {
      .el-input {
        width: 80%;
      }

      .el-button {
        width: 20%;
      }
    }
  }
}

@media screen and (max-width: 1350px) {
  .header {
    width: calc(100% - 40px);
    padding: 0 20px;

    .left {
      .el-dropdown {
        margin: 0 30px;

        .el-dropdown-link {
          font-size: 14px;
        }

        .el-icon-arrow-down {
          font-size: 12px;
        }
      }
    }

    .center {
      .el-input {
        font-size: 14px;
      }

      .el-button {
        font-size: 14px;
        padding: 12px 0;
      }
    }

    @media screen and (max-width: 1000px) {
      .center {
        width: 230px !important;
        min-width: 230px !important;
      }
    }

    @media screen and (max-width: 900px) {
      .center {
        display: none;
      }
    }

    .right {
      right: 20px;
    }

    .app-download, .login {
      margin: 0 5px;
    }
  }
}
</style>
